@if (datasets.length === 1) {
  <ch-single-dataset
    [dataset]="datasets[0]"
    [jobs]="sessionData.jobsMap"
    [sessionData]="sessionData"
    [tools]="tools"
    [parametersLimit]="-1"></ch-single-dataset>
}

@if (datasets.length > 1) {
  <ch-files-details [datasets]="datasets" [sessionData]="sessionData"></ch-files-details>
}
